import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { openWhatsApp, SUMMER_COUPON_CODE } from '../constants';

const points = [
  'Do not waste your summer holidays. Build a future skill now.',
  'Use this break to learn coding from absolute basics.',
  "Today's investment in learning becomes tomorrow's success.",
];

const BATCH_TOTAL = 5;
const BATCH_SIZE  = 8;

export default function SummerOffer() {
  const navigate = useNavigate();
  const location = useLocation();

  const isCoursesPage = location.pathname === '/courses';

  return (
    <section className="section-sm" style={{ background: 'var(--cream)' }}>
      <div className="container">
        <div
          style={{
            background: 'linear-gradient(135deg, #ffd86a 0%, #f0b429 35%, #f3a63a 100%)',
            borderRadius: 24,
            padding: '36px 28px',
            boxShadow: '0 12px 30px rgba(240,180,41,0.25)',
            border: '2px solid rgba(27,58,107,0.08)',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 24,
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {/* ── Left: copy ── */}
            <div style={{ flex: '1 1 360px' }}>
              <div
                style={{
                  display: 'inline-block',
                  background: 'rgba(27,58,107,0.12)',
                  color: 'var(--navy)',
                  padding: '6px 14px',
                  borderRadius: 999,
                  fontWeight: 800,
                  fontSize: 12,
                  letterSpacing: 0.4,
                  marginBottom: 12,
                }}
              >
                SUMMER OFFER 2026
              </div>

              <h2
                className="serif"
                style={{
                  color: 'var(--navy)',
                  fontSize: 'clamp(26px, 4vw, 38px)',
                  lineHeight: 1.2,
                  marginBottom: 12,
                }}
              >
                Make This Summer Count
              </h2>

              <p style={{ color: 'rgba(27,58,107,0.85)', fontSize: 16, lineHeight: 1.7, marginBottom: 16 }}>
                Summer holidays are the best time to get ahead. Join VRK Tech Academy summer
                batches and start building real coding skills before the next academic year.
              </p>

              <div style={{ display: 'grid', gap: 8, marginBottom: 20 }}>
                {points.map((point) => (
                  <div key={point} style={{ color: 'rgba(27,58,107,0.88)', fontSize: 15, fontWeight: 700 }}>
                    — {point}
                  </div>
                ))}
              </div>

              {/* ── Coupon callout ── */}
              <div
                style={{
                  background: 'rgba(27,58,107,0.10)',
                  border: '2px dashed rgba(27,58,107,0.35)',
                  borderRadius: 14,
                  padding: '14px 18px',
                  marginBottom: 14,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 14,
                  flexWrap: 'wrap',
                }}
              >
                <div style={{ fontSize: 24 }}>🏷️</div>
                <div>
                  <div style={{ color: 'var(--navy)', fontWeight: 900, fontSize: 13, marginBottom: 3 }}>
                    ADDITIONAL SUMMER DISCOUNT
                  </div>
                  <div style={{ color: 'var(--navy)', fontSize: 15, fontWeight: 700 }}>
                    Use coupon{' '}
                    <span
                      style={{
                        background: 'var(--navy)',
                        color: '#F0B429',
                        padding: '2px 10px',
                        borderRadius: 6,
                        fontFamily: 'monospace',
                        fontSize: 16,
                        letterSpacing: 1,
                      }}
                    >
                      {SUMMER_COUPON_CODE}
                    </span>{' '}
                    to get{' '}
                    <span style={{ color: '#8b1a1a', fontWeight: 900 }}>50% off</span> on any course!
                  </div>
                  <div style={{ color: 'rgba(27,58,107,0.65)', fontSize: 13, marginTop: 3 }}>
                    Enter the code on the Registration Page to apply the discount.
                  </div>
                </div>
              </div>

              {/* ── Batch info strip ── */}
              <div
                style={{
                  background: 'rgba(27,58,107,0.10)',
                  borderRadius: 14,
                  padding: '14px 18px',
                  border: '1.5px solid rgba(27,58,107,0.18)',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 16,
                  alignItems: 'center',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 20 }}>📅</span>
                  <div>
                    <div style={{ color: 'var(--navy)', fontWeight: 900, fontSize: 13 }}>
                      New Batches from
                    </div>
                    <div style={{ color: 'var(--navy)', fontWeight: 800, fontSize: 15 }}>
                      20 April <span style={{ fontWeight: 600, fontSize: 12, opacity: 0.7 }}>(start date may vary)</span>
                    </div>
                  </div>
                </div>

                <div style={{ width: 1, height: 36, background: 'rgba(27,58,107,0.2)' }} />

                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 20 }}>🏫</span>
                  <div>
                    <div style={{ color: 'var(--navy)', fontWeight: 900, fontSize: 13 }}>
                      Only {BATCH_TOTAL} Batches
                    </div>
                    <div style={{ color: 'var(--navy)', fontWeight: 700, fontSize: 13, opacity: 0.8 }}>
                      This Summer
                    </div>
                  </div>
                </div>

                <div style={{ width: 1, height: 36, background: 'rgba(27,58,107,0.2)' }} />

                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 20 }}>👥</span>
                  <div>
                    <div style={{ color: 'var(--navy)', fontWeight: 900, fontSize: 13 }}>
                      Max {BATCH_SIZE} Students
                    </div>
                    <div style={{ color: 'var(--navy)', fontWeight: 700, fontSize: 13, opacity: 0.8 }}>
                      Per Batch
                    </div>
                  </div>
                </div>
              </div>

              {/* Hurry up callout */}
              <div
                style={{
                  marginTop: 12,
                  background: 'rgba(180,30,30,0.10)',
                  border: '1.5px solid rgba(180,30,30,0.22)',
                  borderRadius: 10,
                  padding: '9px 14px',
                  color: '#8b1a1a',
                  fontWeight: 800,
                  fontSize: 14,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                🔥 Only {BATCH_TOTAL * BATCH_SIZE} seats available in total — Hurry Up, spots fill fast!
              </div>
            </div>

            {/* ── Right: CTA card ── */}
            <div
              style={{
                flex: '1 1 260px',
                background: 'rgba(255,255,255,0.32)',
                borderRadius: 18,
                padding: 20,
                border: '1.5px solid rgba(27,58,107,0.14)',
                textAlign: 'center',
              }}
            >
              <div style={{ color: 'var(--navy)', fontSize: 13, fontWeight: 800, marginBottom: 8 }}>
                LIMITED SUMMER SEATS
              </div>
              <div style={{ color: 'var(--navy)', fontSize: 34, fontWeight: 900, lineHeight: 1 }}>
                FREE
              </div>
              <div style={{ color: 'rgba(27,58,107,0.76)', fontWeight: 700, marginBottom: 4 }}>
                First Class + Career Guidance
              </div>

              {/* Coupon badge */}
              <div
                style={{
                  background: 'rgba(27,58,107,0.1)',
                  border: '1.5px dashed rgba(27,58,107,0.3)',
                  borderRadius: 10,
                  padding: '8px 12px',
                  marginBottom: 10,
                  fontSize: 13,
                  color: 'var(--navy)',
                  fontWeight: 800,
                }}
              >
                🏷️ Use code{' '}
                <span
                  style={{
                    background: 'var(--navy)',
                    color: '#F0B429',
                    padding: '1px 8px',
                    borderRadius: 5,
                    fontFamily: 'monospace',
                    letterSpacing: 1,
                  }}
                >
                  {SUMMER_COUPON_CODE}
                </span>{' '}
                → <span style={{ color: '#8b1a1a' }}>50% OFF</span>
              </div>

              {/* Mini seat summary */}
              <div
                style={{
                  background: 'rgba(27,58,107,0.08)',
                  borderRadius: 10,
                  padding: '8px 12px',
                  marginBottom: 16,
                  fontSize: 13,
                  color: 'var(--navy)',
                  fontWeight: 700,
                  lineHeight: 1.6,
                }}
              >
                🗓️ Starts ~20 April &nbsp;|&nbsp; {BATCH_TOTAL} Batches<br />
                👤 {BATCH_SIZE} students / batch &nbsp;|&nbsp; {BATCH_TOTAL * BATCH_SIZE} seats only
              </div>

              <div style={{ display: 'grid', gap: 10 }}>
                <button className="btn-primary" onClick={() => navigate('/register')}>
                  Register for Course
                </button>

                {!isCoursesPage && (
                  <button className="btn-gold" onClick={() => navigate('/courses')}>
                    View Summer Courses
                  </button>
                )}

                <button
                  className="btn-whatsapp"
                  onClick={() =>
                    openWhatsApp('Hi! I want to join the VRK Tech Academy Summer Offer batch.')
                  }
                >
                  WhatsApp Summer Enquiry
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}